import { gHelpWiki } from "@coreapp/whitelabel/brand";

export function LaunchHelpCode(helpCode, getLink) {
  if (helpCode == null) return;
  var langCode = "en";
  var helpURL = gHelpWiki;
  helpURL += helpCode.indexOf(langCode) > -1 ? "" : "/" + langCode;
  if (helpCode) helpURL += typeof helpCode === "string" ? "/" + helpCode : "/" + helpCode.join("/");
  if (getLink) return helpURL;
  window.open(helpURL);
}
